module.exports = __webpack_public_path__ + "img/logo-telecom-paristech.270fda86.png";